import { scaleIncrementDown, scaleIncrementUp } from "@builder/store/slices/frameTransformSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { useEffect } from "react";

const usePreventZoom = (scrollCheck = true, keyboardCheck = true): void => {
	const dispatch = useAppDispatch();
	const deviceSkin = useAppSelector(state => state.frameTransform.deviceSkin);
	const zoomDisabled = useAppSelector(state => state.frameTransform.zoomDisabled);

	

	useEffect(() => {
		const handleKeydown = (e: KeyboardEvent) => {
			if (keyboardCheck && e.ctrlKey && (e.key === "+" || e.key === "-" || e.key === '=')) {
				e.preventDefault();
				if (zoomDisabled) return;
				if (e.key === "-") dispatch(scaleIncrementDown());
				if (e.key === "+" || e.key === "=") dispatch(scaleIncrementUp());
			}
		};

		const handleWheel = (e: WheelEvent) => {
			if (scrollCheck && e.ctrlKey) {
				e.preventDefault();
				if (deviceSkin || zoomDisabled) return;
				if (e.deltaY > 0 ) {
					dispatch(scaleIncrementDown());
				} else if (e.deltaY < 0) {
					dispatch(scaleIncrementUp());
				}
			}
		};

			document.addEventListener("keydown", handleKeydown);
			document.addEventListener("wheel", handleWheel, { passive: false });

		


		return () => {
			document.removeEventListener("keydown", handleKeydown);
			document.removeEventListener("wheel", handleWheel);
		};
	}, [scrollCheck, keyboardCheck, dispatch, zoomDisabled]);
};

export default usePreventZoom;
